import React, { useState } from 'react';
import { connect } from 'react-redux';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  FormHelperText,
  Grid,
  Switch,
  TextField
} from '@material-ui/core';

import { addExpenseType } from 'redux/actions';

const ExpenseTypeDetails = (props) => {

  const [typeName, setTypeName] = useState("");
  const [vatable, setVatable] = useState(false);

  const handleSubmit = (event) => {
    event.preventDefault();
    
    const newType = {
      name: typeName,
      vatable
    };
    props.addExpenseType(newType);

    expenseTypeCleanup();
  };

  const expenseTypeCleanup = () => {
    setTypeName("");
    setVatable(false);
  };

  return (
    <form
      autoComplete="off"
      onSubmit={handleSubmit}
    >
      <Card>
        <CardHeader
          subheader="This will add a New Expense Type."
          title="New Expense Type"
        />
        <Divider />
        <CardContent>
          <Grid
            container
            spacing={3}
          >
            <Grid
              item
              md={6}
              xs={12}
            >
              <TextField
                fullWidth
                helperText="Please Enter the Expense Type"
                label="Expense Type"
                onChange={(event) => setTypeName(event.target.value)}
                required
                value={typeName}
                variant="outlined"
              />
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
              container
              direction="column"
              alignItems="center"
            >
              <FormHelperText>Toggle if Type is Vatable:</FormHelperText>
              <Switch
                checked={vatable}
                onChange={() => setVatable(!vatable)}
                color="primary"
                name="vatable"
              />
            </Grid>
          </Grid>
        </CardContent>
        <Divider />
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            p: 2
          }}
        >
          <Button
            color="primary"
            variant="contained"
            type="submit"
          >
            Save details
          </Button>
          <Button sx={{ mx: 1 }} onClick={expenseTypeCleanup}>
            Cancel
          </Button>
        </Box>
      </Card>
    </form>
  )
};

export default connect (null, {addExpenseType}) (ExpenseTypeDetails);